/**
 * Chạy sớm (import đầu main) để set base API v1 theo host agency: chatapi.{apex}/api/v1
 * và cờ site agency (social.{apex} nhưng không thuộc hub list).
 */
function normalizeList(raw) {
    return String(raw || "")
        .split(",")
        .map((s) => s.trim().toLowerCase())
        .filter(Boolean);
}
export function normalizeHostname(host) {
    return String(host || "")
        .trim()
        .toLowerCase()
        .replace(/\.+$/g, "");
}
/** Origin không kèm dấu chấm thừa cuối host (tránh `https://social.chatteam.asia./path`). */
export function socialPageOrigin() {
    if (typeof window === "undefined") {
        return "";
    }
    const host = normalizeHostname(window.location.hostname);
    const { protocol, port } = window.location;
    const defaultPort = protocol === "https:" ? "443" : "80";
    const portPart = port && port !== defaultPort ? `:${port}` : "";
    return `${protocol}//${host}${portPart}`;
}
function withTrailingDot(prefix) {
    const p = String(prefix || "").trim().toLowerCase();
    if (!p)
        return "";
    return p.endsWith(".") ? p : `${p}.`;
}
/** Hub legacy — luôn dùng api.chatteam.asia, không coi là agency branch. */
const DEFAULT_HUB_SOCIAL_HOSTS = ["social.chatteam.asia"];
/** Apex hub legacy: social.{apex} với apex này không bao giờ là agency site. */
const LEGACY_HUB_APEXES = ["chatteam.asia"];
function mergeHubSocialHosts() {
    const fromEnv = normalizeList(process.env.VUE_APP_AGENCY_HUB_SOCIAL_HOSTS);
    return [...new Set([...DEFAULT_HUB_SOCIAL_HOSTS, ...fromEnv])];
}
(function initAgencyRuntime() {
    if (typeof window === "undefined") {
        return;
    }
    const rawHost = window.location.hostname;
    const host = normalizeHostname(rawHost);
    if (rawHost !== host) {
        const { protocol, pathname, search, hash } = window.location;
        window.location.replace(`${protocol}//${host}${pathname}${search}${hash}`);
        return;
    }
    const hubHosts = mergeHubSocialHosts();
    const socialPrefix = withTrailingDot(process.env.VUE_APP_AGENCY_SOCIAL_PREFIX || "social.");
    const apiPrefix = withTrailingDot(process.env.VUE_APP_AGENCY_API_PREFIX || "chatapi.");
    const isSocialHost = !!(socialPrefix && host.startsWith(socialPrefix));
    const apex = isSocialHost ? host.substring(socialPrefix.length) : null;
    const isLegacyHubApex = !!(apex && LEGACY_HUB_APEXES.includes(apex));
    const isHubSocial = hubHosts.includes(host) || isLegacyHubApex;
    const isAgencySite = isSocialHost && !isHubSocial;
    window.__SOCIAL_IS_AGENCY_SITE = isAgencySite;
    window.__SOCIAL_AGENCY_APEX = isAgencySite && apex ? apex : null;
    window.__SOCIAL_BUILD_ID = process.env.VUE_APP_BUILD_ID || "";
    const hubApiBase = (process.env.VUE_APP_API_BASE_URL || "").replace(/\/$/, "") + "/v1";
    if (isAgencySite && window.__SOCIAL_AGENCY_APEX) {
        const proto = window.location.protocol === "https:" ? "https:" : "http:";
        window.__SOCIAL_API_BASE_V1 = `${proto}//${apiPrefix}${window.__SOCIAL_AGENCY_APEX}/api/v1`;
    }
    else {
        window.__SOCIAL_API_BASE_V1 = hubApiBase;
    }
})();
export function isHubSocialHost(host) {
    if (typeof window === "undefined") {
        return false;
    }
    const h = normalizeHostname(host || window.location.hostname);
    const socialPrefix = withTrailingDot(process.env.VUE_APP_AGENCY_SOCIAL_PREFIX || "social.");
    const apex = socialPrefix && h.startsWith(socialPrefix)
        ? h.substring(socialPrefix.length)
        : null;
    return mergeHubSocialHosts().includes(h) || !!(apex && LEGACY_HUB_APEXES.includes(apex));
}
export function isAgencySocialSite() {
    return typeof window !== "undefined" && !!window.__SOCIAL_IS_AGENCY_SITE;
}
export function agencyBranchConfigUrl() {
    if (!isAgencySocialSite() || !window.__SOCIAL_AGENCY_APEX) {
        return null;
    }
    const proto = window.location.protocol === "https:" ? "https:" : "http:";
    const apiPrefix = withTrailingDot(process.env.VUE_APP_AGENCY_API_PREFIX || "chatapi.");
    return `${proto}//${apiPrefix}${window.__SOCIAL_AGENCY_APEX}/api/agency/v1/branch-config`;
}
/**
 * Base URL trang quản lý đơn / Agency Dashboard.
 * - Agency site (social.{apex}): https://{apex}
 * - Hub: VUE_APP_HUB_ORDERS_URL hoặc fallback gmv.asia.
 */
export function ordersBaseUrl() {
    if (typeof window === "undefined") {
        return process.env.VUE_APP_HUB_ORDERS_URL || "https://gmv.asia";
    }
    const proto = window.location.protocol === "https:" ? "https:" : "http:";
    if (isAgencySocialSite() && window.__SOCIAL_AGENCY_APEX) {
        return `${proto}//${window.__SOCIAL_AGENCY_APEX}`;
    }
    const hub = (process.env.VUE_APP_HUB_ORDERS_URL || "https://gmv.asia").replace(/\/+$/, "");
    return hub;
}
export function ordersDashboardUrl() {
    return `${ordersBaseUrl().replace(/\/+$/, "")}/report`;
}
export function ordersDetailUrl(orderCode) {
    const code = encodeURIComponent(String(orderCode || "").trim());
    return `${ordersBaseUrl().replace(/\/+$/, "")}/don-hang?code=${code}&code_type=1&select_start_date_type=1&select_end_date_type=1`;
}
